/* eslint-disable react/prop-types */
/**
 * ArticlesProvider
 * Contain most logic handling with Omnitech Api
 */

import React from 'react'
import { createPersistedState } from '../../cache'
import OrderMethodContext from './order-method-context'

export default function OrderMethodProvider({ children }) {
  const useOrderMethodState = createPersistedState('orderMethod')
  const useOrderMethodBeforeMenuState = createPersistedState('orderMethodBeforeMenu')
  const useStoreState = createPersistedState('store')
  const useDeliveryAddressState = createPersistedState('deliveryAddress')

  const [orderMethod, setOrderMethod] = useOrderMethodState()
  const [orderMethodBeforeMenu, setOrderMethodBeforeMenu] = useOrderMethodBeforeMenuState()
  const [deliveryAddress, setDeliveryAddress] = useDeliveryAddressState()
  const [store, setStore] = useStoreState()

  const clearOrderMethod = () => {
    setOrderMethod({})
    setOrderMethodBeforeMenu({})
    setDeliveryAddress({})
    setStore({})
  }

  const state = {
    setDeliveryAddress,
    setOrderMethod,
    setOrderMethodBeforeMenu,
    setStore,
    clearOrderMethod,
    deliveryAddress,
    orderMethod,
    orderMethodBeforeMenu,
    store
  }

  return (
    <OrderMethodContext.Provider value={state}>
      {children}
    </OrderMethodContext.Provider>
  )
}
